// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"aa1ac72d","334":"6ccd6393","377":"861fb3a6","509":"70baecaa","521":"e07f0866","790":"06269b8b","801":"f26a3179","834":"b94aee9e","926":"b0236759"}[chunkId] + ".chunk.js";
};